document.addEventListener("DOMContentLoaded", () => {
  // Video Controls
  const videos = document.querySelectorAll("video");
  if (!videos.length) return;

  videos.forEach((video) => {
    let videoStarted = false;

    // NOTE: appears unused, leaving as-is to avoid changing behavior elsewhere
    const videoControls = document.getElementById("video-controls");

    const playButton = video.parentNode.querySelector(".video-play");
    if (!playButton) return;

    // Wrapper + poster surface (reliable poster restore on iOS)
    const wrap = video.closest(".video-wrap") || video.parentNode;
    const posterUrl = video.getAttribute("poster");

    if (wrap && posterUrl) {
      wrap.style.setProperty("--video-poster", `url("${posterUrl}")`);
      wrap.classList.add("has-poster", "show-poster");
    }

    function showPosterSurface() {
      if (wrap && posterUrl) wrap.classList.add("show-poster");
    }

    function hidePosterSurface() {
      if (wrap && posterUrl) wrap.classList.remove("show-poster");
    }

    // State sync:
    // - Playing: show native controls, hide overlay, hide poster surface
    // - Paused mid-video: keep native controls ON (so scrubbing works), hide overlay
    // - At start (t=0) or ended: hide native controls, show overlay, show poster surface
    function syncUI() {
      const atStart = video.currentTime === 0 && (video.paused || video.ended);
      const atEnd = !!video.ended;

      if (!video.paused && !video.ended) {
        // Playing
        hidePosterSurface();
        video.controls = true;
        playButton.classList.add("d-none");
        video.classList.add("pointer");
        return;
      }

      // Paused or ended
      if (atEnd || atStart) {
        // Start/end state: show poster + overlay
        showPosterSurface();
        video.controls = false;
        playButton.classList.remove("d-none");
        video.classList.remove("pointer");
      } else {
        // Paused mid-video: keep controls so user can scrub; hide overlay to avoid blocking / double-play look (iOS)
        hidePosterSurface();
        video.controls = true;
        playButton.classList.add("d-none");
        video.classList.remove("pointer");
      }
    }

    function playVideo() {
      if (!videoStarted) {
        // set video start time to 0, allowing you to specify a poster frame timestamp
        video.currentTime = 0;
        videoStarted = true;
      }

      const playPromise = video.play();
      if (playPromise && typeof playPromise.catch === "function") {
        playPromise.catch(() => {
          // If playback fails (policy/error), keep UI usable
          video.controls = false;
          playButton.classList.remove("d-none");
          showPosterSurface();
        });
      }
      syncUI();
    }

    function pauseVideo() {
      video.pause();
      syncUI();
    }

    // Overlay play button toggles play/pause
    playButton.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();

      if (video.paused || video.ended) {
        playVideo();
      } else {
        pauseVideo();
      }
    });

    // Click-to-pause on the video (not fullscreen)
    video.addEventListener("click", () => {
      if (!video.paused && video.height < 700) {
        pauseVideo();
      }
    });

    // Keep UI in sync with real video state changes (native controls, keyboard, etc.)
    video.addEventListener("play", syncUI);
    video.addEventListener("pause", syncUI);

    // Ended: reset to poster reliably (esp. iOS)
    video.addEventListener("ended", () => {
      videoStarted = false;
      video.pause();
      video.currentTime = 0;

      // Return to poster + overlay state
      video.controls = false;
      playButton.classList.remove("d-none");
      showPosterSurface();

      // Helps poster rendering in some browsers
      video.load();
      syncUI();
    });

    // Standard fullscreen change (most browsers)
    video.addEventListener("fullscreenchange", () => {
      // If minimized from fullscreen and paused, resync UI
      if (video.height < 500 && video.paused) {
        syncUI();
      }
    });

    // iOS Safari fullscreen exit (fullscreenchange isn't reliable there)
    video.addEventListener("webkitendfullscreen", () => {
      // Just resync; keeps things consistent
      syncUI();
    });

    // Initialize UI state
    video.controls = false;
    syncUI();
  });
});
